import {
	createContext,
	Dispatch,
	ReactNode,
	useContext,
	useReducer,
} from 'react';

import {
	initialState as productCardInitialState,
	ProductCardAction,
	productCardReducer,
	State as ProductCardState,
} from 'Reducers/productCard';

type ProductCardContextType = {
	state: ProductCardState;
	dispatch: Dispatch<ProductCardAction>;
};

const ProductCardContext = createContext<ProductCardContextType>({
	state: productCardInitialState,
	dispatch: () => {},
} as ProductCardContextType);

export const useProductCardContext = () => {
	return useContext(ProductCardContext);
};

type Props = {
	children: ReactNode;
};

export const ProductCardProvider = ({ children }: Props) => {
	const [state, dispatch] = useReducer(
		productCardReducer,
		productCardInitialState,
	);

	return (
		<ProductCardContext.Provider value={{ state, dispatch }}>
			{children}
		</ProductCardContext.Provider>
	);
};
